import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-subject-grace',
  templateUrl: './subject-grace.component.html',
  styleUrls: ['./subject-grace.component.scss']
})
export class SubjectGraceComponent implements OnInit {
subjectGrace:FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  SessionNo: any;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.subjectGrace = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
    })
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchList() {
    let payload = {}
    payload["SnNo"] = this.SessionNo;
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMarks = res.data;
        this.filteredListOfMarks = this.ListOfMarks.slice();
      }
      else {

      }

    });

  }
}
